/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutRequestBody
 */
export interface PutRequestBody {
    /**
     * 
     * @type {number}
     * @memberof PutRequestBody
     */
    babyId?: number;
    /**
     * 
     * @type {string}
     * @memberof PutRequestBody
     */
    dateMeeting?: string;
    /**
     * 
     * @type {number}
     * @memberof PutRequestBody
     */
    id?: number;
}

/**
 * Check if a given object implements the PutRequestBody interface.
 */
export function instanceOfPutRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PutRequestBodyFromJSON(json: any): PutRequestBody {
    return PutRequestBodyFromJSONTyped(json, false);
}

export function PutRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'babyId': !exists(json, 'babyId') ? undefined : json['babyId'],
        'dateMeeting': !exists(json, 'dateMeeting') ? undefined : json['dateMeeting'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function PutRequestBodyToJSON(value?: PutRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'babyId': value.babyId,
        'dateMeeting': value.dateMeeting,
        'id': value.id,
    };
}

